export default __webpack_public_path__ + "images/HA.907059c.png";